import classNames from 'classnames';
import { S } from '@mobily/ts-belt';
import { Box, Stack, Text } from '@stitch-fix/mode-react';
import {
  type CloudinaryImageFields,
  CloudinaryImageWrapper,
} from '../CloudinaryImageWrapper';
import styles from './styles.module.scss';
import { MODE_MIN_WIDTH } from '../../utils/values/mediaQueries';

export interface ImageContent1UpProps {
  title?: string;
  items: {
    title: string;
    description: string;
  }[];
  image: CloudinaryImageFields;
  showItemsDivider?: boolean;
  imagePlacement?: 'left' | 'right';
}

export const ImageContent1Up = ({
  title,
  image: { src, alt, cloudinaryAsset },
  items,
  showItemsDivider = true,
  imagePlacement = 'left',
}: ImageContent1UpProps) => (
  <Box
    className={classNames(styles.container, {
      [styles.imageRight]: imagePlacement === 'right',
    })}
  >
    <CloudinaryImageWrapper
      src={src}
      alt={alt}
      sources={{
        sm: 560,
        md: 720,
      }}
      cloudinaryAsset={cloudinaryAsset}
      maxContainerWidth={1264}
      sizes={[
        { minWidth: MODE_MIN_WIDTH.sm, staticWidth: 23.5 * 16 },
        { minWidth: 768, staticWidth: 38.625 * 16 },
        { minWidth: MODE_MIN_WIDTH.xl, fluidWidth: 30 },
      ]}
      imageProps={{ loading: 'lazy' }}
    />
    <Box className={styles.textContent}>
      <Stack spacing={2}>
        <Text setting="title-medium">{title}</Text>
        <Stack spacing={1.5} divider={showItemsDivider ? 'item' : undefined}>
          {items.map(item => (
            <Box key={item.title}>
              {S.isNotEmpty(item.title) && (
                <Text setting="title-xsmall" spacingBottom>
                  {item.title}
                </Text>
              )}
              {S.isNotEmpty(item.description) && (
                <Text setting="body-small">{item.description}</Text>
              )}
            </Box>
          ))}
        </Stack>
      </Stack>
    </Box>
  </Box>
);
